export const createCustomLegendPlugin = (options) => ({
    id: 'customLegend',
    beforeUpdate(chart) {
        if (options.doHideLegend && chart.options.plugins?.legend?.display) {
            chart.options.plugins.legend.display = false;
        }
    },
    afterUpdate(chart) {
        const datasetsProperties = [];
        chart.data.datasets.forEach((dataset, datasetIndex) => {
            datasetsProperties.push({
                datasetIndex,
                dataset,
                isHidden: !chart.isDatasetVisible(datasetIndex),
                toggleVisibility: () => {
                    chart.setDatasetVisibility(datasetIndex, !chart.isDatasetVisible(datasetIndex));
                    chart.update();
                },
            });
        }, []);
        const datasetsPropertiesCached = options.getDatasetsProperties();
        let isEqual = datasetsPropertiesCached.length === datasetsProperties.length;
        if (isEqual) {
            datasetsProperties.forEach((datasetProperties, index) => {
                if (datasetProperties.datasetIndex !== datasetsPropertiesCached[index].datasetIndex
                    || datasetProperties.dataset !== datasetsPropertiesCached[index].dataset
                    || datasetProperties.isHidden !== datasetsPropertiesCached[index].isHidden) {
                    isEqual = false;
                    return;
                }
                datasetsProperties[index] = datasetsPropertiesCached[index];
            });
        }
        if (!isEqual) {
            options.setDatasetsProperties(datasetsProperties);
        }
    },
});
//# sourceMappingURL=customLegendPlugin.js.map